/** Display helpers for the communication channel (TECH-626). Kept React-free for tests. */
import type { Channel } from '@/types';

export const CHANNEL_LABEL: Record<Channel, string> = {
  email: 'Email',
  sms: 'SMS/MMS',
};

/** Bootstrap icon per channel; MMS gets its own glyph in the explorer. */
export const CHANNEL_ICON: Record<Channel, string> = {
  email: 'bi-envelope',
  sms: 'bi-chat-left-text',
};

export const MMS_ICON = 'bi-paperclip';

/** Chart colour per channel (email = brand blue, sms = teal). */
export const CHANNEL_COLOR: Record<Channel, string> = {
  email: '#3B82F6',
  sms: '#14B8A6',
};

/** Icon + label for a row: 📧 Email / 💬 SMS / 📎 MMS. */
export function channelBadge(channel: Channel, hasMedia = false): { icon: string; label: string } {
  if (channel === 'sms') {
    return hasMedia ? { icon: MMS_ICON, label: 'MMS' } : { icon: CHANNEL_ICON.sms, label: 'SMS' };
  }
  return { icon: CHANNEL_ICON.email, label: 'Email' };
}

/** Normalise an unknown string from the API to a Channel (defaults to email). */
export function toChannel(value: string | null | undefined): Channel {
  return value?.toLowerCase() === 'sms' ? 'sms' : 'email';
}
